import { Button } from '@/components/ui/button';

/** Pagination limit/offset (format { data, total, limit, offset } de missions/maintenance/fuel, cf. TD-034). */
export const OffsetPager = ({ total, limit, offset, onChange }: {
  total: number; limit: number; offset: number; onChange: (offset: number) => void;
}) => {
  if (total <= limit) return null;
  return (
    <div className="flex items-center justify-between gap-2 p-3 border-t text-sm">
      <span className="text-muted-foreground tabular-nums">
        {offset + 1}–{Math.min(offset + limit, total)} sur {total}
      </span>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={offset === 0} onClick={() => onChange(Math.max(0, offset - limit))}>
          Précédent
        </Button>
        <Button variant="outline" size="sm" disabled={offset + limit >= total} onClick={() => onChange(offset + limit)}>
          Suivant
        </Button>
      </div>
    </div>
  );
};
